import { createAction, props } from '@ngrx/store';

type LoadRascunhosEmAnaliseProps = {
  pageNumber: number;
  pageSize: number;
  conteudoLivre?: string;
  tipoEstabelecimento?: string;
  novoCadastro?: string;
  cadastroAtualizado?: string;
  semAlteracao?: string;
  direcaoOrdenacao?: string;
  atributoOrdenacao?: string;
};

export const loadRascunhosEmAnalise = createAction(
  '[Rascunho Analise] Load Rascunhos Em Analise',
  props<LoadRascunhosEmAnaliseProps>()
);

export const loadRascunhosEmAnaliseSuccess = createAction(
  '[Rascunho Analise] Load Rascunhos Em Analise Success',
  props<{ data: RascunhoAnaliseResponse }>()
);

export const loadRascunhosEmAnaliseFailure = createAction(
  '[Rascunho Analise] Load Rascunhos Em Analise Failure',
  props<{ error: RascunhoAnaliseResponse }>()
);
